import { arrayToObject } from 'lib/array/arrayUtils'

export default function loyaltyInclusionFilter(
  pkgLoyaltyInclusions: App.PackageInclusion[],
  commonAndBonusInclusions: App.PackageInclusion[],
): App.PackageInclusion[] {
  /*
      If LuxPLus+ inclusions already exist as common or bonus inclusions for regular customers (e.g. daily breakfast, etc),
      we want to allow them to keep those inclusions.

      As a result we prevent duplication in the UI by filtering out those inclusions by comparing the inclusion type.
  */
  const commonAndBonusInclusionsByType = arrayToObject(
    commonAndBonusInclusions,
    (incl) => incl.type || '',
    (incl) => incl,
  )

  return pkgLoyaltyInclusions.filter((loyaltyInclusion) => {
    const isAlsoCommonOrBonusInclusion = (loyaltyInclusion.type || '') in commonAndBonusInclusionsByType
    return !isAlsoCommonOrBonusInclusion
  })
}
